<template>
  <div class="card bs">
    <div class="card-body">
      <div class="pagespeed-infographic">
        <div class="row text-center header-row">
          <div class="col-4">
          </div>
          <div class="col-4">
            <label>Normal Page</label>
          </div>
          <div class="col-4">
            <label><IconBolt height="14" class="no-primary" />AMP</label>
          </div>
        </div>
        <div class="row">
          <div class="col-4 flex-center">
            <p>Speed Index</p>
          </div>
          <div class="col-4 flex-center">
            <p class="num">{{result.normal['speed-index'].score}}<sub>/100</sub></p>
          </div>
          <div class="col-4 flex-center">
            <p class="num"><span class="em-line">{{result.amp['speed-index'].score}}<sub>/100</sub></span></p>
          </div>
        </div>
        <div class="row">
          <div class="col-4 flex-center">
            <p>Page Loading Time</p>
          </div>
          <div class="col-4 flex-center">
            <p class="num">{{result.normal['first-contentful-paint'].displayValue}}</p>
          </div>
          <div class="col-4 flex-center">
            <p class="num"><span class="em-line">{{result.amp['first-contentful-paint'].displayValue}}</span></p>
          </div>
        </div>
        <div class="row">
          <div class="col-4 flex-center">
            <p>Time to Interactive</p>
          </div>
          <div class="col-4 flex-center">
            <p class="num">{{result.normal['interactive'].displayValue}}</p>
          </div>
          <div class="col-4 flex-center">
            <p class="num"><span class="em-line">{{result.amp['interactive'].displayValue}}</span></p>
          </div>
        </div>
        <div class="row">
          <div class="col-4 flex-center">
            <p>First CPU Idle</p>
          </div>
          <div class="col-4 flex-center">
            <p class="num">{{result.normal['first-cpu-idle'].displayValue}}</p>
          </div>
          <div class="col-4 flex-center">
            <p class="num"><span class="em-line">{{result.amp['first-cpu-idle'].displayValue}}</span></p>
          </div>
        </div>
        <div class="row">
          <div class="col-4 flex-center">
            <p>Estimated Input Latency</p>
          </div>
          <div class="col-4 flex-center">
            <p class="num">{{result.normal['estimated-input-latency'].displayValue}}</p>
          </div>
          <div class="col-4 flex-center">
            <p class="num"><span class="em-line">{{result.amp['estimated-input-latency'].displayValue}}</span></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    result: Object
  }
}
</script>

<style lang="scss">
.pagespeed-infographic {
  font-weight: 400;
  text-align: center;

  svg {
    margin-left: -7px;
  }

  label, p {
    margin-bottom: 0;
  }

  .row + .row {
    margin-top: 1rem;
  }

  .row:not(.header-row) {
    .col-4 {
      height: 50px;
    }
  }

  .num {
    font-size: 1.4rem;

    sub {
      display: inline-block;
      font-size: 0.7rem;
      margin-right: -5px;
      bottom: 0;
    }
  }
}
</style>
